export default __webpack_public_path__ + "static/media/casal.269cb334.png";